import React, {} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {iconHeight, iconLength, iconLink, iconThickness} from "../../../../../../assetsSQFT";
import {
  waterfallSectionInterface,
  waterfallSegmentInterface
} from "../../../../../../interfaces/sqftInterfaces";

import {changeResource} from "../../../../../../../../actions/sqftResourceFunctions";
import workspaceControllers from "../../../../../canvas/store/workspaceControllers";
import NavWaterfallSegmentSwitcher from "./NavWaterfallSegmentSwitcher";
import config from "../../../../../canvas/store/sqftConfig";
import {MEASURE_UNITS} from "../../../../../../constants";

const NavWaterfallSegment = (props) => {
  const {waterfallSegmentData, index} = props;
  void index;

  let segmentLength = waterfallSegmentData.length;
  let segmentThickness = waterfallSegmentData.thickness;
  const waterfallSegment = workspaceControllers.waterfall.getSegmentById(waterfallSegmentData.id);

  //todo
  //let segmentMaxLength = waterfallSection.getMaxLength();

  const changeLength = (newValue) => {
    workspaceControllers.waterfall.segmentController.changeSegmentLength(waterfallSegmentData.id, newValue);
  }

  const changeThickness = (newValue) => {
    workspaceControllers.waterfall.segmentController.changeSegmentThickness(waterfallSegmentData.id, newValue);
  }

  const changeHeight = (value) => {
    workspaceControllers.waterfall.segmentController.changeSegmentHeight(waterfallSegmentData.id, value);
  }

  const getHeightName = () => {
    return waterfallSegment.USE_DEPTH_INSTEAD_OF_HEIGHT.includes(waterfallSegmentData.name) ? 'depth' : 'height';
  }

  return (
    <div className={"segment-container " + (waterfallSegmentData.isDisabled ? " segment-container--disabled" : null)}>
      <div className="segment-header">
        <div className="segment-name">
          <FormattedMessage id={"sqft.navigation.waterfall." + waterfallSegmentData.name}/>
        </div>
        <NavWaterfallSegmentSwitcher waterfallSegmentData={waterfallSegmentData}/>
      </div>
      <ul className="mitered-segment segment-params">
        <li className="mitered-segment__content segment-height">
          {/*<div className="segment-letter">{numToLetter(index + 1)}</div>*/}
          <div className="segment-image">
            <img src={iconHeight} alt=""/>
          </div>
          <div className="segment-value">
            <input className={"ui-input segment-value-input " + (config.measureUnit === MEASURE_UNITS.Metric ? "segment-value-input__metric" : "")}
                   type="number"
                   min="0"
                   onChange={(e) => changeHeight(e.target.value)}
                   placeholder={waterfallSegmentData.height}
                   value={waterfallSegmentData.height} />
          </div>
          <div className="segment-description">
            <div>
              {
                waterfallSegment.COMMON_HEIGHT.includes(waterfallSegmentData.name)
                  ? <img src={iconLink} alt=""/>
                  : ""
              }
            </div>
            <div>
              <FormattedMessage id={"sqft.navigation.waterfall." + getHeightName()}/>
            </div>
          </div>
        </li>
        <li className="mitered-segment__content segment-length">
          <div className="segment-image">
            <img src={iconLength} alt=""/>
          </div>
          <div className="segment-value">
            <input type="number"
              //max={segmentMaxLength}
                   min="0"
                   className={"ui-input segment-value-input " + (config.measureUnit === MEASURE_UNITS.Metric ? "segment-value-input__metric" : "")}
                   placeholder={segmentLength}
                   value={segmentLength}
                   disabled={waterfallSegment.USE_LINE_LENGTH.includes(waterfallSegmentData.name)}
                   onChange={(e) => changeLength(e.target.value)} />
          </div>
          <div className="segment-description">
            <FormattedMessage id={"sqft.navigation.waterfall.length"}/>
          </div>
        </li>
        <li className="mitered-segment__content segment-thickness">
          <div className="segment-image">
            <img src={iconThickness} alt=""/>
          </div>
          <div className="segment-value">
            <input type="number"
                   min="0"
                   className={"ui-input segment-value-input " + (config.measureUnit === MEASURE_UNITS.Metric ? "segment-value-input__metric" : "")}
                   placeholder={segmentThickness}
                   value={segmentThickness}
                   onChange={(e) => changeThickness(e.target.value)} />
          </div>
          <div className="segment-description">
            <FormattedMessage id={"sqft.navigation.waterfall.thickness"}/>
          </div>
        </li>
      </ul>
    </div>
  );
};

NavWaterfallSegment.propTypes = {
  waterfallSegmentData: PropTypes.shape(waterfallSegmentInterface),
  waterfallSectionData: PropTypes.shape(waterfallSectionInterface)
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {
  changeResource
};


export default connect(mapStateToProps, mapDispatchToProps)(NavWaterfallSegment);
